import React, { Fragment } from 'react';
import { arrayOf, object, string, bool } from 'prop-types';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown/with-html';

import Divider from './Divider';
import WelcomeTooltip from './WelcomeTooltipContainer';
import Dropdown from './DropdownContainer';
import ProductsList from '../../subscription/components/ProductsList';
import InformationDetail from '../../subscription/components/InformationDetail';
import Observations from '../../subscription/components/Observations';


const Container = styled.section`
  padding: 64px 0px;
  background-color: #f6f6f6;
  margin: 0 auto;

  @media(min-width: 1000px) {
    width: 970px;
  }
`;

const Title = styled(ReactMarkdown)`
  * {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 24px;
    line-height: 1.33;
    margin-bottom: 32px;
    text-align: center;
    color: #4a4a4a;
  }

  strong {
    font-weight: bold;
  }

  @media(max-width: 999px) {
    margin-left: 24px;
    margin-right: 24px;
  }
`;

const SubTitle = styled(ReactMarkdown)`
  * {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 16px;
    line-height: 1.5;
    margin-top: -20px;
    margin-bottom: 32px;
    text-align: center;
    color: #4a4a4a;
  }

  strong {
    font-weight: bold;
  }

  a {
    color: #9027b0;
    text-decoration: none;
  }

  @media(max-width: 999px) {
    margin-left: 24px;
    margin-right: 24px;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const flexPlanList = (posName) => {
  if (posName === 'cars-subscription') {
    return [
      { text: '5 até 15', value: 5 },
      { text: '15 até 30', value: 15 },
      { text: '30 até 50', value: 30 },
      { text: '50 até 80', value: 50 },
      { text: 'Acima de 80', value: 80 },
    ];
  } else if (posName === 'cars-subscription-mkt') {
    return [
      { text: '5 até 15', value: 5 },
      { text: '15 até 30', value: 15 },
      { text: '30 até 50', value: 30 },
      { text: '50 até 80', value: 50 },
      { text: 'Acima de 80', value: 80 },
    ];
  } else if (posName === 'realestate-subscription-mkt') {
    return [
      { text: '5 até 20', value: 5 },
      { text: '20 até 40', value: 20 },
      { text: '40 até 60', value: 40 },
      { text: '60 até 200', value: 60 },
      { text: 'Acima de 200', value: 200 },
    ];
  }

  return [
    { text: '5 até 20', value: 5 },
    { text: '20 até 40', value: 20 },
    { text: '40 até 60', value: 40 },
    { text: '60 até 100', value: 60 },
    { text: 'Acima de 100', value: 100 },
  ];
};

const TitleAndSubtitle = ({ title, subtitle }) => (
  <Fragment>
    <Title escapeHtml={false}>{title}</Title>
    {subtitle && <SubTitle escapeHtml={false}>{subtitle}</SubTitle>}
  </Fragment>
);

TitleAndSubtitle.propTypes = {
  title: string.isRequired,
  subtitle: string,
};

TitleAndSubtitle.defaultProps = {
  subtitle: undefined,
};

const PlanBox = ({
  subscriptions, info, title, subtitle, isBlackFriday, details, posName, showDropdown,
}) => (
  <Container id="plans">
    <SectionHeader>
      <Divider />
      {posName !== 'cars-subscription' && posName !== 'realestate-subscription' ? <TitleAndSubtitle title={title} subtitle={subtitle} /> : null}
      {(posName === 'cars-subscription-mkt' || posName === 'realestate-subscription-mkt') &&
      <Fragment>
        <WelcomeTooltip />
        <Dropdown list={flexPlanList(posName)} title="Selecionar tamanho" />
      </Fragment>}

      {showDropdown &&
        <Fragment>
          <TitleAndSubtitle title={title} />
          <WelcomeTooltip />
          <Dropdown list={flexPlanList(posName)} title="Selecionar tamanho" />
        </Fragment>
      }

    </SectionHeader>
    <ProductsList products={subscriptions} isBlackFriday={isBlackFriday} />
    {details && <Observations details={details} />}
    {info && <InformationDetail info={info} />}
  </Container>
);

PlanBox.propTypes = {
  subscriptions: arrayOf(object),
  posName: string,
  info: string,
  title: string,
  subtitle: string,
  isBlackFriday: bool,
  details: arrayOf(string),
  showDropdown: bool,
};

PlanBox.defaultProps = {
  posName: '',
  subscriptions: [],
  info: undefined,
  title: 'Escolha seu Plano e comece a anunciar agora na OLX:',
  subtitle: undefined,
  isBlackFriday: false,
  showDropdown: false,
  details: [],
};

export default PlanBox;
